import { useTranslation } from 'react-i18next'

import PropTypes from 'prop-types'

import { Switch, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ExceptionNotification = ({ exception, handleChange }) => {
  const { t } = useTranslation()

  return (
    <Styles.SectionContainer>
      <Text type="titleS">{t('Notificación')}</Text>
      <Switch
        checked={exception?.send_notification_on_creation}
        label={t('Enviar notificación al cliente')}
        onChange={e => handleChange('send_notification_on_creation', e.target.checked)}
      />
    </Styles.SectionContainer>
  )
}

ExceptionNotification.propTypes = {
  exception: PropTypes.object,
  handleChange: PropTypes.func,
}

export default ExceptionNotification
